import React from 'react';
export const UserContext = React.createContext();
export const QCContext = React.createContext();